import {AfterViewInit, Directive, ElementRef, Optional, Self} from '@angular/core';
import {TextBoxComponent} from '../text-box/text-box.component';

@Directive({
    selector: '[focus]'
})
export class FocusDirective implements AfterViewInit {
    constructor(private element: ElementRef,
                @Self() @Optional() private textBox: TextBoxComponent) {
    }

    ngAfterViewInit(): void {
    }
}
